import { addDoc, collection, deleteDoc, doc, updateDoc } from "firebase/firestore"
import Swal from "sweetalert2"
import { db } from "../firebase/firebase-config"
import { fileUpload } from "../helpers/fileUpload"
import { loadNotes } from "../helpers/loadNotes"
import { types } from "../types/types"

export const startAddNewNote = () => {
    return async (dispatch, getState) => {

        const { uid } = getState().auth
        
        const newNote = {
            title: '',
            body: '',
            date: new Date().getTime(),
            url: ''
        }

        try {
            const doc = await addDoc(collection(db, `${uid}/journal/notes`), newNote)
            console.log(doc.id)

            dispatch(activeNote(doc.id, newNote))
            dispatch(addNewNote(doc.id, newNote))
        } catch (e) {
            Swal.fire('Error', e.code, 'error')
        }
        
    }
}

export const activeNote = (id, note) => {
    return {
        type: types.notesSetActive,
        payload: {
            id,
            ...note
        }
    }
}

export const addNewNote = (id, note) => {
    return {
        type: types.notesAddNew,
        payload: { 
            id, ...note
        }
    }
}

export const startLoadingNotes = (uid) => {
    return async (dispatch) => {

        const notes = await loadNotes(uid)
        dispatch(setNotes(notes))
    }
}

export const setNotes = (notes) => {
    return {
        type: types.notesLoad,
        payload: notes
    }
}

export const startUpdateNote = (note) => {
    return async (dispatch, getState) => {

        const { uid } = getState().auth

        const { id, ...noteToUpdate } = note

        try {
            await updateDoc(doc(db, `${uid}/journal/notes/${note.id}`), noteToUpdate)
        } catch (e) {
            console.log(e)
        }

        dispatch(refreshNote(note))
        Swal.fire('Saved', note.title, 'success')
    }
}

export const refreshNote = (note) => {
    return {
        type: types.notesUpdate,
        payload: {
            id: note.id,
            note: note
        }
    }
}

export const startPictureUpload = (file) => {
    return async (dispatch, getState) => {

        const { active: activeNote } = getState().notes

        Swal.fire({
            title: 'Uploading...',
            text: 'Please wait...',
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading()
            }
        })

        const pictureUrl = await fileUpload(file)
        activeNote.url = pictureUrl

        dispatch(startUpdateNote(activeNote))

        Swal.close()
    }
}

export const startDelete = (id) => {
    return async (dispatch, getState) => {

        const { uid } = getState().auth

        try {
            await deleteDoc(doc(db, `${uid}/journal/notes/${id}`))
        } catch (error) {
            throw error
        }

        dispatch(deleteNote(id))
    }
}

export const deleteNote = (id) => {
    return {
        type: types.notesDelete,
        payload: id
    }
}

export const notesLogout = () => {
    return {
        type: types.notesCleaning
    }
}